module.exports = __webpack_public_path__ + "static/media/background.468c3cf2.png";